import React, {useEffect, useState} from 'react';
import '../../styles/style.css';
import ArrowRightIcon from '../../assets/images/arrow-right.png';
import BASE from "../../config";
import bed from "../../assets/images/bed.png";
import axios from "axios";
import stripHTMLTags from "../../functions";
import {Link} from "react-router-dom";

const Mobile_Villas = () => {

  const [visibleRows, setVisibleRows] = useState(3);

  const handleLoadMore = () => {
    setVisibleRows(visibleRows + 3);
  };


  const [resorts, setResorts] =  useState([]);

  useEffect(() =>{
    axios.get(BASE.BASE_API_URL+'/api/resorts').then( res => {
      // console.log("RESORTS WITH PROP",res);
      setResorts(res.data.resorts);

  })
  },[]);


// console.log("Mobile Resorts",resorts);
  return (
    <div className="slider_area_villas mobile">
      <div className="container">
        <div className="slider_heading"><h1>Luxury Villa Collection</h1></div>
        {
          resorts.slice(0, visibleRows).map((villa, index) => (
          <div className="slider_inner_content" key={villa.id ?? index}>
            <img src={BASE.BASE_IMAGES_PATH+"/categories/"+villa.image} alt={villa.title} />
            <div className="inner_data_slider">
              <h3>{villa.title}</h3>
              <p>
                {stripHTMLTags(villa.description)
                    .replace(/&nbsp;/g, ' ')
                    .replace(/&euro;/g, '€')
                    .replace(/&rsquo;/g, "'")
                    .substring(0, 30)} ...
              </p>
              <div className="bedrooms_villas">
                <div className="bedrooms_villas_left">
                  <p>2-5<span role="img" aria-label="bed"> <img src={bed}  /></span>Room</p>
                </div>
                <div className="bedrooms_villas_right">
                  <Link to={`/${villa.title.toLowerCase().replace(/\s+/g, "-")}/${villa.id}`}>
                    View More <img src={ArrowRightIcon} alt="Arrow Right" style={{ marginLeft: '8px', width: '12px', height: '12px', marginTop: '5px' }} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}


        {visibleRows < resorts.length && (
          <button className="load-more-btn" onClick={handleLoadMore}>
            Load More
          </button>
        )}
      </div>
    </div>


  );
};

export default Mobile_Villas;
